import { gql } from '~/src/generated/portal/gql';

const GET_TEST_SCRIPT_STATUS = gql(`
  query scriptTestStatus ($projectId: String!, $deviceId: String, $testId: String!) {
    adkTestScriptStatus(
      projectId: $projectId,
      deviceId: $deviceId,
      testId: $testId
    ) {
       id
        timeStamp
        testIndex
        actionIndex
        testExecutionId
        description
        tests {
          initialPageStatus {
            initialPage
            status
            error
          }
          description
          actions {
            description
            preCommands
            expectations
            postCommands
            status
            error
            preScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            } 
            postScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            }
            totalScreenshots 
            allScreenshots {
              name
              status
              images {
                src
                width
                height
                format
                isOriginal
              }
              takenAt
            }
          }
          error
        }
        error
    }
  }
`);

export default GET_TEST_SCRIPT_STATUS;
